import { FC } from "react";
import { TextField, FormHelperText } from "@mui/material";
import { iLabelInputFieldProps } from "./../../../types/formtypes";
import "./labelInputFiled.css";
import typography from "../../../theme/typography";

const LabelInputField: FC<iLabelInputFieldProps> = ({
	required,
	disabled,
	error,
	errorTextOnly = false,
	id,
	onChange,
	label,
	type,
	placeholder,
	value,
	InputProps,
	className,
	helperText,
	onBlur,
	keyUpHanlder,
	autoFocus,
}) => {
	const showErrorOnInput = error && !errorTextOnly;

	return (
		<>
			<TextField
				fullWidth
				required={required}
				disabled={disabled}
				error={showErrorOnInput}
				id={id}
				onChange={onChange}
				label={label}
				type={type}
				placeholder={placeholder}
				value={value}
				className={`inputHold ${className}`}
				helperText={errorTextOnly ? undefined : helperText}
				onBlur={onBlur}
				onKeyUp={keyUpHanlder}
				autoFocus={autoFocus}
				slotProps={{
					input: InputProps,
					inputLabel: { shrink: true }
				}} />
			{errorTextOnly && helperText && (
				<FormHelperText
					error
					sx={{
						mt: 0.5,
						mx: 1.75,
						fontFamily: typography.fontPrimaryGeneralSans,
						fontWeight: typography.fontWeightNormal,
					}}
				>
					{helperText}
				</FormHelperText>
			)}
		</>
	);
};
export default LabelInputField;
